module.exports = __webpack_public_path__ + "media/images/writer/story_achievement_mailer/congratulations-6a62bef24a00c7856cc4aa3464dbc95a.png";